import keyMirror from 'keymirror';

export default keyMirror({
    USER_PREFERENCE_INSERT_COMPLETED: null,
});
